import axios from 'axios'

const baseUrl = process.env.VUE_APP_API_URL || ''
let unauthorizedHandler = null
let isHandlingUnauthorized = false

const api = axios.create({
    baseURL: baseUrl,
})

export function setAuthToken(token) {
    api.defaults.headers.common['Authorization'] = `Bearer ${token}`
}

export function clearAuthToken() {
    delete api.defaults.headers.common['Authorization']
}

export function setUnauthorizedHandler(handler) {
    unauthorizedHandler = handler
}

// Если токен есть в localStorage при старте — активируем
const savedToken = localStorage.getItem('token')
if (savedToken) setAuthToken(savedToken)

api.interceptors.response.use(
    (response) => response,
    (error) => {
        const status = error?.response?.status
        const requestUrl = String(error?.config?.url || '')
        const isLoginRequest = requestUrl === '/auth' || requestUrl.endsWith('/auth')
        const isTokenCheckRequest = requestUrl.includes('/auth/check')

        if (
            status === 401 &&
            unauthorizedHandler &&
            !isLoginRequest &&
            !isTokenCheckRequest &&
            !isHandlingUnauthorized
        ) {
            isHandlingUnauthorized = true
            try {
                unauthorizedHandler(error)
            } finally {
                isHandlingUnauthorized = false
            }
        }

        return Promise.reject(error)
    }
)

export default api
